import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace'
import { useTranslation } from 'react-i18next'
import { makeStyles } from '@mui/styles'
import { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { getPaymentPeriod, handleDetails } from '../actions/driverActionsUS'
import { showAlertSnackbar } from '../reducers/sliceReducer'
import { sortKeys } from '../utilities/common'
import dayjs from 'dayjs'

const useStyles = makeStyles(theme => ({
  root: {
    width: 315,
    marginTop: 22,
    marginLeft: 'auto',
    marginRight: 'auto'
  },
  title: {
    color: '#101820',
    fontSize: 24,
    fontWeight: 'bold',
    letterSpacing: 0,
    marginTop: 44
  },
  subTitle: {
    backgroundColor: '#EBECEF',
    marginTop: 15,
    height: 19,
    width: 109,
    color: '#101820',
    fontSize: 16,
    fontWeight: 'bold',
    letterSpacing: 0,
    paddingTop: 7,
    paddingBottom: 7,
    paddingLeft: 9,
    paddingRight: 197
  },
  periods: {
    marginTop: 35
  },
  period: {
    borderBottom: '2px solid rgba(13,25,35,0.2)',
    minWidth: 315,
    paddingBottom: 8,
    paddingLeft: 0.5,
    marginTop: 14
  }
}))

function IncomeDetails() {
  const classes = useStyles()
  const history = useHistory()
  const dispatch = useDispatch()
  const { t } = useTranslation('incomeDetails')

  const currentDateRange = useSelector(
    state => state.driverUSReducer.getSettlementTimeList
  )

  const [firstStart, setFirstStart] = useState('')
  const [firstStartTime, setFirstStartTime] = useState('')
  const [firstEnd, setFirstEnd] = useState('')
  const [firstEndTime, setFirstEndTime] = useState('')

  const [secondStart, setSecondStart] = useState('')
  const [secondStartTime, setSecondStartTime] = useState('')
  const [secondEnd, setSecondEnd] = useState('')
  const [secondEndTime, setSecondEndTime] = useState('')

  const [thirdStart, setThirdStart] = useState('')
  const [thirdStartTime, setThirdStartTime] = useState('')
  const [thirdEnd, setThirdEnd] = useState('')
  const [thirdEndTime, setThirdEndTime] = useState('')

  const [fourthStart, setFourthStart] = useState('')
  const [fourthStartTime, setFourthStartTime] = useState('')
  const [fourthEnd, setFourthEnd] = useState('')
  const [fourthEndTime, setFourthEndTime] = useState('')

  async function handleStatement(period, date) {
    if (process.env.REACT_APP_COUNTRY === 'CA') {
      if (period === 1) {
        window.localStorage.setItem('current-start', firstStart)
        window.localStorage.setItem('current-start-time', firstStartTime)
        window.localStorage.setItem('current-end', firstEnd)
        window.localStorage.setItem('current-end-time', firstEndTime)
      } else if (period === 2) {
        window.localStorage.setItem('current-start', secondStart)
        window.localStorage.setItem('current-start-time', secondStartTime)
        window.localStorage.setItem('current-end', secondEnd)
        window.localStorage.setItem('current-end-time', secondEndTime)
      } else if (period === 3) {
        window.localStorage.setItem('current-start', thirdStart)
        window.localStorage.setItem('current-start-time', thirdStartTime)
        window.localStorage.setItem('current-end', thirdEnd)
        window.localStorage.setItem('current-end-time', thirdEndTime)
      } else if (period === 4) {
        window.localStorage.setItem('current-start', fourthStart)
        window.localStorage.setItem('current-start-time', fourthStartTime)
        window.localStorage.setItem('current-end', fourthEnd)
        window.localStorage.setItem('current-end-time', fourthEndTime)
      }
      history.push('/driverMobile/incomeStatement')
    } else {
      try {
        let subjectId = window.localStorage.getItem('subject_id')
        window.localStorage.setItem('current-start-end', date)
        let promises = {}
        await Promise.all(
          currentDateRange[date].days.map(async (day, key) => {
            await dispatch(
              getPaymentPeriod(subjectId, day.start, day.end)
            ).then(res => {
              promises[day.date] = res
            })
          })
        )
        await dispatch(handleDetails(sortKeys(promises)))
        await history.push('/driverMobile/deliveryStatements')
      } catch {
        dispatch(showAlertSnackbar({ message: t('contact_it'), type: 'error' }))
      }
    }
  }

  useEffect(() => {
    setFirstStart(window.localStorage.getItem('lastStart'))
    setFirstStartTime(window.localStorage.getItem('lastStartTime'))
    setFirstEnd(window.localStorage.getItem('lastEnd'))
    setFirstEndTime(window.localStorage.getItem('lastEndTime'))

    let secondStart = ''
    let secondStartTime = ''
    let secondEnd = ''
    let secondEndTime = ''

    let thirdStart = ''
    let thirdStartTime = ''
    let thirdEnd = ''
    let thirdEndTime = ''

    let fourthStart = ''
    let fourthStartTime = ''
    let fourthEnd = ''
    let fourthEndTime = ''

    const current = dayjs()

    if (current.date() <= 15) {
      secondStart = current.subtract(1, 'month').date(1)
      secondEnd = current.subtract(1, 'month').date(15)
      thirdStart = current.subtract(2, 'month').date(16)
      thirdEnd = current.subtract(2, 'month').endOf('month')
      fourthStart = current.subtract(2, 'month').date(1)
      fourthEnd = current.subtract(2, 'month').date(15)
    } else {
      secondStart = current.subtract(1, 'month').date(16)
      secondEnd = current.subtract(1, 'month').endOf('month')
      thirdStart = current.subtract(1, 'month').date(1)
      thirdEnd = current.subtract(1, 'month').date(15)
      fourthStart = current.subtract(2, 'month').date(16)
      fourthEnd = current.subtract(2, 'month').endOf('month')
    }

    // Prepare backend values, add 1 day for end times because database tables are named that way
    secondStartTime = secondStart.format('YYYYMMDD')
    secondEndTime = secondEnd.add(1, 'day').format('YYYYMMDD')
    thirdStartTime = thirdStart.format('YYYYMMDD')
    thirdEndTime = thirdEnd.add(1, 'day').format('YYYYMMDD')
    fourthStartTime = fourthStart.format('YYYYMMDD')
    fourthEndTime = fourthEnd.add(1, 'day').format('YYYYMMDD')

    // Prepare display values
    secondStart = secondStart.format('MMM D')
    secondEnd = secondEnd.format('MMM D')
    thirdStart = thirdStart.format('MMM D')
    thirdEnd = thirdEnd.format('MMM D')
    fourthStart = fourthStart.format('MMM D')
    fourthEnd = fourthEnd.format('MMM D')

    setSecondStart(secondStart)
    setSecondStartTime(secondStartTime)
    setSecondEnd(secondEnd)
    setSecondEndTime(secondEndTime)
    setThirdStart(thirdStart)
    setThirdStartTime(thirdStartTime)
    setThirdEnd(thirdEnd)
    setThirdEndTime(thirdEndTime)
    setFourthStart(fourthStart)
    setFourthStartTime(fourthStartTime)
    setFourthEnd(fourthEnd)
    setFourthEndTime(fourthEndTime)
  }, [])

  return (
    <div className={classes.root}>
      <div onClick={() => history.goBack()}>
        <KeyboardBackspaceIcon fontSize='large' />
      </div>
      {process.env.REACT_APP_COUNTRY === 'CA' ? (
        <div>
          <div className={classes.title}>Income Statements</div>
          <div className={classes.subTitle}>Last 60 days</div>
          <div className={classes.periods}>
            <div className={classes.period} onClick={() => handleStatement(1)}>
              {firstStart} - {firstEnd}
            </div>
            <div className={classes.period} onClick={() => handleStatement(2)}>
              {secondStart} - {secondEnd}
            </div>
            <div className={classes.period} onClick={() => handleStatement(3)}>
              {thirdStart} - {thirdEnd}
            </div>
            <div className={classes.period} onClick={() => handleStatement(4)}>
              {fourthStart} - {fourthEnd}
            </div>
          </div>
        </div>
      ) : (
        <div>
          <div className={classes.title}>Settlement History</div>
          <div className={classes.subTitle}>Last 28 days</div>
          <div className={classes.periods}>
            {Object.keys(currentDateRange).map((date, index) => (
              <div key={date}>
                {index !== 0 && (
                  <div
                    className={classes.period}
                    onClick={() => handleStatement(4, date)}>
                    {date}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  )
}

export default IncomeDetails
